"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=function(e,s){return null===e||(e.classList?e.classList.add(s):e.className+=" ".concat(s)),e};
//# sourceMappingURL=addClass.js.map
